import React, { useEffect, useState } from 'react';
import Spinner from './Components/spinner';
import { postData } from '@/services/api.service';
import { Link, useParams } from 'react-router';
import { end_points } from '@/services/endpoints';
import NoProducts from './Components/noProduct';
import { routePrefix } from '@/utils/routes/routes';
import { useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';

const SearchResult = () => {
  const { value: inputValue } = useParams();
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState<{ [key: number]: boolean }>({});
  const [products, setProducts] = useState<any[]>([]);
  const currencyCode = useSelector(
    (state: RootState) => state.common.header?.currency?.symbol
  );

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await postData(end_points.search.url, {
        keyword: inputValue,
        type: 'service'
      });
      setProducts(response.data.data);
    } catch (err) {
      console.error('Search error:', err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };
  console.log("prod123", products)
  useEffect(() => {
    fetchData();
  }, [inputValue]);

  const toggleReadMore = (index: number) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const truncateHTML = (html: string, wordLimit: number): string => {
    return html.length > wordLimit ? html.slice(0, wordLimit) + '...' : html;
  };

  return (
    <div className="search-result-wrapper">
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-section mb-3">
        <div className="container">
          <h1 className="page-title">
            Search results for <b>"{inputValue}"</b>
          </h1>
        </div>
      </div> */}

      {loading ? (
        <Spinner />
      ) : (
        <div className="container mt-4">
          {products.length > 0 ? (
            <div className="search-page-product-list row">
              {products.map((product, index) => {
                const isExpanded = expanded[index];
                const fullText = product?.product_details || '';
                const displayText = isExpanded
                  ? fullText
                  : truncateHTML(fullText, 125);
                return (
                  <React.Fragment key={product.id}>
                    <div className='col-md-6'>
                      <Link to={`${routePrefix}/product-details/${product.id}`} className='search-page-product-list-card'>
                        <div className="search-page-product-img">
                          <img
                            src={`${product?.image_path}${product.image}`}
                            alt={product?.name}
                          />
                        </div>
                        <div className="search-page-prod-info-grid">
                          <div className="search-page-prod-info">
                            <div className="search-page-prod-info-s">
                              <h5 className="search-product-name">
                                {product?.name}
                              </h5>
                            </div>
                            <div className="search-page-prod-info-hr"></div>
                            <div className="search-page-prod-info-e">
                              <div className="search-page-prod-price">
                                <span className='cur-symbol'>{currencyCode}</span>{product?.price}
                              </div>
                            </div>
                          </div>
                          <div className="search-page-prod-info-desc">
                            {fullText && (
                              <div className="text-muted small">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: displayText,
                                  }}
                                />
                                {fullText.split(/\s+/).length > 125 && (
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleReadMore(index);
                                    }}
                                    style={{
                                      color: '#007bff',
                                      cursor: 'pointer',
                                      display: 'inline-block',
                                      marginTop: '5px',
                                    }}
                                  >
                                    {isExpanded ? 'Read less' : 'Read more'}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          ) : (
            <NoProducts />
          )}
        </div>
      )}
    </div>
  );
};

export default SearchResult;
